import React, { useEffect, useState } from "react";
import {
  CombineInputGroup,
  InputGroup,
  Label,
} from "../../../Components/Styles/InputStyles";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";

export default function StudentDetails({
  tenantData,
  setSelectedData,
  addOccupationDetailMutate,
  isOccupationDetailLoading,
}) {
  const [data, setData] = useState(tenantData?.tenant);

  useEffect(() => {
    setData(tenantData?.tenant);
  }, [tenantData]);

  const occupationFormik = useFormik({
    initialValues: {
      institutionName: data?.institutionName || "",
      institutionEmail: data?.institutionEmail || "",
      institutionId: data?.institutionId || "",
    },
    validationSchema: Yup.object({
      institutionName: Yup.string(),
      institutionEmail: Yup.string(),
      institutionId: Yup.string(),
    }),
    onSubmit: (values) => {
      if (!values.institutionName) {
        toast.error("Institution Name is required");
        return;
      }
      if (!values.institutionEmail) {
        toast.error("Institution Email is required");
        return;
      }
      if(!values.institutionId){
        toast.error("Institution Id is required");
        return;
      }
      addOccupationDetailMutate(values);
    },
    enableReinitialize: true,
  });

  return (
    <>
      <div>
        <Title>Occupation Details</Title>
        <form
          onSubmit={occupationFormik.handleSubmit}
          className="grid grid-cols-1 gap-4"
        >
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="institutionName">Institution Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="institutionName"
                  name="institutionName"
                  value={occupationFormik.values.institutionName}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
                {occupationFormik.touched.institutionName &&
                  occupationFormik.errors.institutionName && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.institutionName}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="institutionEmail">Institution Email</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="institutionEmail"
                  name="institutionEmail"
                  value={occupationFormik.values.institutionEmail}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
                {occupationFormik.touched.institutionEmail &&
                  occupationFormik.errors.institutionEmail && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.institutionEmail}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="institutionId">Institution ID</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="institutionId"
                  name="institutionId"
                  value={occupationFormik.values.institutionId}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
                {occupationFormik.touched.institutionId &&
                  occupationFormik.errors.institutionId && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.institutionId}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <BtnWrapper>
            <SubmitBtn type="submit" disabled={isOccupationDetailLoading}>
              {isOccupationDetailLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </div>
    </>
  );
}

const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;

const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
const SubmitBtn = tw.button`text-sm  w-24  md:w-20 h-7 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-full shadow-md`;
